{
  "TRANSFER_TO_AGENT": {
    "TOOLTIP": "Předat na operátora",
    "MESSAGE": "Předej na operátora"
  },
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "Stáhnout",
      "UPLOADING": "Nahrávání..."
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Odeslat"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "Odeslat zprávu znovu",
      "ERROR_MESSAGE": "Odeslání se nezdařilo, zkuste to znovu"
    },
    "MESSAGE_RATING": {
      "TOOLTIP": "Ohodnotit kvalitu odpovědi"
    }
  },
  "WAITING_FOR_AGENT": {
    "MESSAGE": "Prosím vyčkejte na připojení operátora"
  },
  "ROBOT_CHECK": {
    "TITLE": "Rychlé bezpečnostní ověření",
    "DESCRIPTION": "Prosím dokončete kontrolu níže.",
    "VERIFYING": "Ověřujeme…",
    "ERROR": "Ověření se nezdařilo. Zkuste to prosím znovu.",
    "RETRY": "Zkusit znovu"
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "Jsme online",
    "OFFLINE": "V současné době jsme pryč",
    "ONLINE_WITH_BOT": "Náš tým a AI asistent jsou online",
    "OFFLINE_WITH_BOT": "Náš AI asistent je k dispozici",
    "BOT_ONLY_REPLY": "Odpovídá okamžitě"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "Většinou odpovíme během pár minut",
    "IN_A_FEW_HOURS": "Většinou odpovíme během pár hodin",
    "IN_A_DAY": "Obvykle odpoví za den",
    "BACK_IN": "Budeme online opět v"
  },
  "DAY_NAMES": {
    "SUNDAY": "Neděle",
    "MONDAY": "Pondělí",
    "TUESDAY": "Úterý",
    "WEDNESDAY": "Středa",
    "THURSDAY": "Čtvrtek",
    "FRIDAY": "Pátek",
    "SATURDAY": "Sobota"
  },
  "START_CONVERSATION": "Zahájit konverzaci",
  "END_CONVERSATION": "Ukončit konverzaci",
  "CONTINUE_CONVERSATION": "Pokračovat v konverzaci",
  "YOU": "Vy",
  "START_NEW_CONVERSATION": "Zahájit novou konverzaci",
  "RESOLVE_LATER": "Toto téma dořešíme přes email/telefon. Chci se teď zeptat ještě na něco dalšího.",
  "VIEW_UNREAD_MESSAGES": "Máte nepřečtené zprávy",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "Zobrazit nové zprávy",
    "CLOSE_MESSAGES_BUTTON": "Zavřít",
    "COMPANY_FROM": "od",
    "BOT": "Bot"
  },
  "BUBBLE": {
    "LABEL": "Napište nám"
  },
  "POWERED_BY": "Powered by {brandName}",
  "EMAIL_PLACEHOLDER": "Prosím, zadejte svůj e-mail",
  "CHAT_PLACEHOLDER": "Zde začněte psát",
  "TODAY": "Dnes",
  "YESTERDAY": "Včera",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "Celé jméno",
        "PLACEHOLDER": "Zadejte své celé jméno",
        "REQUIRED_ERROR": "Je vyžadováno celé jméno"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "E-mailová adresa",
        "PLACEHOLDER": "Zadejte prosím Váš e-mail",
        "REQUIRED_ERROR": "E-mailová adresa je vyžadována",
        "VALID_ERROR": "Zadejte prosím platnou e-mailovou adresu"
      },
      "PHONE_NUMBER": {
        "LABEL": "Telefonní číslo",
        "PLACEHOLDER": "Zadejte prosím Vaše telefonní číslo",
        "REQUIRED_ERROR": "Telefonní číslo je vyžadováno",
        "DIAL_CODE_VALID_ERROR": "Vyberte prosím kód země",
        "VALID_ERROR": "Zadejte prosím platné telefonní číslo",
        "DROPDOWN_EMPTY": "Žádné výsledky",
        "DROPDOWN_SEARCH": "Vyhledat zemi"
      },
      "MESSAGE": {
        "LABEL": "Zpráva",
        "PLACEHOLDER": "Zadejte prosím Vaši zprávu",
        "ERROR": "Zpráva je příliš krátká"
      }
    },
    "CAMPAIGN_HEADER": "Zadejte, prosím, své jméno a e-mail před zahájením konverzace",
    "IS_REQUIRED": "je vyžadováno",
    "REQUIRED": "Povinné",
    "REGEX_ERROR": "Zadejte prosím platnou hodnotu"
  },
  "FILE_SIZE_LIMIT": "Soubor překračuje limit {MAXIMUM_FILE_UPLOAD_SIZE} přílohy",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Neplatné pole"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "Hledat emoji",
    "NOT_FOUND": "Žádné emoji neodpovídají vašemu hledání",
    "ARIA_LABEL": "Výběr emoji"
  },
  "CSAT": {
    "TITLE": "Ohodnoťte svou konverzaci",
    "SUBMITTED_TITLE": "Děkujeme Vám za odeslání hodnocení",
    "PLACEHOLDER": "Řekněte nám více..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "Požádat o přepis konverzace",
    "SEND_EMAIL_SUCCESS": "Přepis chatu byl úspěšně odeslán",
    "SEND_EMAIL_ERROR": "Došlo k chybě, zkuste to prosím znovu"
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Populární články",
    "VIEW_ALL_ARTICLES": "Zobrazit všechny články",
    "IFRAME_LOAD_ERROR": "Při načítání článku došlo k chybě, obnovte stránku a zkuste to znovu."
  },
  "CARDS": {
    "ACTIONS": {
      "OPEN": "Otevřít",
      "BUY": "Koupit"
    }
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "Zpráva obrázku"
    },
    "audio": {
      "CONTENT": "Zvuková zpráva"
    },
    "video": {
      "CONTENT": "Video zpráva"
    },
    "file": {
      "CONTENT": "Přílohu souboru"
    },
    "location": {
      "CONTENT": "Poloha"
    },
    "fallback": {
      "CONTENT": "sdílel URL"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "Odpověď na:"
  }
}
